module.exports = __webpack_public_path__ + "static/media/newpageguide.0fd84ee59ab81c8053d83294ba2b9e64.svg";